import { pgpEncrypt } from '@axa-asia/hk-emma-web-module/lib/openpgp/openpgp-utils';
import { goTo } from '../../actions/routing';
import config from '../../config';
import { namesNoAvaliable } from '../../utils/validator';
import { muleSoftFetch } from '../../utils/fetch';
import { parseQueryString } from '../../utils/queryString';
import { mapFeToApiField } from './emma-retrieveAccount';

import {
  USER_TYPE_CWP,
  USER_TYPE_UNDEFINED,
  ROUTE_NAMES,
  FEATURE_CODES,
  POLICY_TYPE_CODES
} from '../../constants/constants';
import {
  formatContactsToArray,
  getShouldShowPicStatement,
} from '../../utils/helpers';
import { getErrorConfig } from '../../utils/error-code';

const INITIAL = 'INITIAL';
const EM_REGIST_SERVER_REQ_START = 'EM_REGIST_SERVER_REQ_START';
const POLICY_SELECTED = 'myaxa/signupLife/POLICY_SELECTED';
const EM_REGIST_SERVER_REQ_COMPLETE = 'EM_REGIST_SERVER_REQ_COMPLETE';
const EM_REGIST_SERVER_KEEP_HASH = 'EM_REGIST_SERVER_KEEP_HASH';
const EM_REGIST_SET_FLAGS = 'EM_REGIST_SET_FLAGS';
const EM_REGIST_FETCH_USERNAME = 'EM_REGIST_FETCH_USERNAME';
const EM_REGIST_SELECT_USERNAME = 'EM_REGIST_SELECT_USERNAME';
const EM_REGIST_INPUT_CARDNO = 'EM_REGIST_INPUT_CARDNO';
const EM_FINDMYPOLICY_SUCCESS = 'EM_FINDMYPOLICY_SUCCESS';
const EM_FINDMYPOLICY_VERIFY = 'EM_FINDMYPOLICY_VERIFY';
const EM_FINDMYPOLICY_NOT_MATCH = 'EM_FINDMYPOLICY_NOT_MATCH';
const EM_FINDMYPOLICY_FAIL = 'EM_FINDMYPOLICY_FAIL';
const EM_FINDPOLICY_CARDTYPE_SEL = 'EM_FINDPOLICY_CARDTYPE_SEL';
const EM_FINDPOLICY_POLICYTYPE_SEL = 'EM_FINDPOLICY_POLICYTYPE_SEL';
const EM_REGIST_REVIEW_BACK = 'EM_REGIST_REVIEW_BACK';
const EM_REGIST_FROM_CHANGED = 'EM_REGIST_FROM_CHANGED';

const initialState = {
  policyType: '',
  cardType: '',
  isSubmitting: false,
  isFindMyPolicySuccess: false,
  userNames: [],
  errorCode: '',
  errorValues: {},
  errorData: {},
  checkHash: '',
  contactInfo: '',
  contactType: '',
  contactIndex: -1,
  email: '',
  mobile: '',
  emailStr: '',
  mobileStr: '',
  countryCode: '',
  hkid: '',
  passport: '',
  chinaid: '',
  dob: '',
  receiveNews: false,
  acceptDataPolicy: false,
  acceptPIC: false,
  insuredAccessFlag: undefined,
  // submit flow
  showForReview: {},
  submitValues: {},
  fromPage: '',
  isShowForReview: false,
  submitHandler: null,
  shouldShowPicStatement: false,
  isSelectUsername: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIAL:
      return {
        ...state,
        isSubmitting: false,
        isShowForReview: false,
      };
    case POLICY_SELECTED:
      return {
        ...state,
        policyType: action.policyType,
      };
    case EM_REGIST_SERVER_REQ_START:
      return {
        ...state,
        isSubmitting: true,
      };
    case EM_REGIST_SERVER_REQ_COMPLETE:
      return {
        ...state,
        isSubmitting: false,
      };
    case EM_REGIST_SERVER_KEEP_HASH:
      return {
        ...state,
        checkHash: action.checkHash,
      };
    case EM_FINDMYPOLICY_SUCCESS:
      return {
        ...state,
        isFindMyPolicySuccess: true,
        errorCode: action.errorCode,
      };
    case EM_FINDMYPOLICY_VERIFY:
      return {
        ...state,
        contactInfo: action.contactInfo,
        contactType: action.contactType,
        countryCode: action.countryCode,
      };
    case EM_FINDMYPOLICY_NOT_MATCH:
      return {
        ...state,
        checkHash: action.checkHash,
        emails: action.emails,
        mobiles: action.mobiles,
      };
    case EM_FINDMYPOLICY_FAIL:
      return {
        ...state,
        isFindMyPolicySuccess: false,
        errorCode: action.errorCode,
        errorValues: action.errorValues,
        errorData: action.errorData,
      };
    case EM_FINDPOLICY_CARDTYPE_SEL:
      return {
        ...state,
        cardType: action.cardType,
      };
    case EM_FINDPOLICY_POLICYTYPE_SEL:
      return {
        ...state,
        policyType: action.policyType,
      };
    case EM_REGIST_SET_FLAGS:
      return {
        ...state,
        insuredAccessFlag: action.insuredAccessFlag,
        selectContactFlag: action.selectContactFlag,
        shouldShowPicStatement: action.shouldShowPicStatement,
        isSelectUsername: action.isSelectUsername,
      };
    case EM_REGIST_FETCH_USERNAME:
      return {
        ...state,
        userNames: action.userNames,
        countryCodeMap: action.countryCodeMap,
      };
    case EM_REGIST_INPUT_CARDNO:
      return {
        ...state,
        policyType: action.policyType,
        hkid: action.hkid,
        passport: action.hkid,
        chinaid: action.chinaid,
        cardType: action.cardType,
        dob: action.dob,
      };
    case EM_REGIST_SELECT_USERNAME:
      return {
        ...state,
        contactType: action.contactType,
        contactIndex: action.contactIndex,
        email: action.email ? action.email : '',
        mobile: action.mobile ? action.mobile : '',
        emailStr: action.emailStr ? action.emailStr : '',
        mobileStr: action.mobileStr ? action.mobileStr : '',
        countryCode: action.countryCode ? action.countryCode : '',
        password: action.password,
        acceptDataPolicy: action.acceptDataPolicy,
        receiveNews: action.receiveNews,
        acceptPIC: action.acceptPIC,
        locale: action.locale,
        analyticsId: action.analyticsId,
      };
    case EM_REGIST_REVIEW_BACK:
      return {
        ...state,
        isShowForReview: true,
      };
    case EM_REGIST_FROM_CHANGED:
      return {
        ...state,
        fromPage: action.fromPage,
      };
    default:
      return state;
  }
}

export const initial = () => {
  return {
    type: INITIAL,
  };
};

const innerRedirectOnPolicyTypeSel = (policyType, dispatch, getState) => {
  const currLang = getState().language.lang;
  dispatch({
    type: EM_FINDPOLICY_POLICYTYPE_SEL,
    policyType,
  });
  const routeName = ROUTE_NAMES[policyType];

  if (routeName) {
    dispatch(
      goTo(
        `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}`,
      ),
    );
  }
};

export const redirectOnPolicyTypeSel = policytype => {
  return (dispatch, getState) => {
    innerRedirectOnPolicyTypeSel(policytype, dispatch, getState);
  };
};

export const gotoPolicyTypeSelect = userType => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    if (userType === USER_TYPE_UNDEFINED) {
      throw new Error('userType should be not undefined');
    }
    if (userType === USER_TYPE_CWP) {
      dispatch(
        goTo(`/${currLang}/${config.webview.identityFEPath}/emma/signup/cwp`),
      );
      return;
    }

    dispatch(
      goTo(
        `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/policy-select?userType=${userType}`,
      ),
    );
  };
};

export const redirectOnCardSelection = selectedCardType => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EM_FINDPOLICY_CARDTYPE_SEL,
      cardType: selectedCardType,
    });
    if (selectedCardType === 'axa') {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/employee-benefit/axa-card-selected`,
        ),
      );
    } else if (selectedCardType === 'other') {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/employee-benefit/other-card-selected`,
        ),
      );
    }
  };
};

export const onPolicySelect = (link, policyType) => {
  return async dispatch => {
    dispatch({
      type: POLICY_SELECTED,
      policyType,
    });
    dispatch(goTo(link));
  };
};

export const emmaSubmitRegist = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const currStateVal = getState();
    // const regObj = currStateVal.emmaRegistration;
    const currLang = currStateVal.language.lang;
    const isEB = submitValues.policyType === 'company';
    const isPnc = submitValues.policyType === 'pnc';
    const entityCode =
      {
        company: 'EHK',
        individual: 'LHK',
      }[submitValues.policyType] || '';
    const routeName = ROUTE_NAMES[submitValues.policyType] || '';

    const body = mapFeToApiField(submitValues);

    dispatch({
      type: EM_REGIST_INPUT_CARDNO,
      entityCode,
      ...body,
    });
    dispatch({
      type: EM_REGIST_SERVER_REQ_START,
    });

    const toBeEncryptedRequest = {
      ...body,
    };

    const encryptedRequest = await pgpEncrypt(
      JSON.stringify(toBeEncryptedRequest),
      config.apiEncryptPublicKey,
    );

    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };

    const formData = {
      searchObject: encryptedRequest,
      captchaToken: submitValues.captchaToken,
    }

    await (config.isMockResponse
      ? Promise.resolve((await import('./mocks/registration')).default)
      : muleSoftFetch(
        `${config.webview.muleApiBaseUrl}/customers/search`,
        'post',
        { searchRequest: formData },
        option,
      )
    )
      .then(({ data }) => {
        if (data.response && data.response.reasonCode) {
          const { reasonCode } = data.response;
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode: reasonCode
          });

          const errorConfig = getErrorConfig({
            apiCode: reasonCode,
            featureCode: FEATURE_CODES.registration,
            policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
          });

          dispatch(
            goTo(
              `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/error?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`,
            ),
          );
          return;
        }
        dispatch({
          type: EM_REGIST_SERVER_KEEP_HASH,
          checkHash: data.checkHash,
        });
        dispatch({ type: EM_REGIST_SERVER_REQ_COMPLETE });
        const { emails, mobiles } = formatContactsToArray(data);
        const userNames = [...emails, ...mobiles];

        dispatch({
          type: EM_REGIST_SET_FLAGS,
          insuredAccessFlag: data.insuredAccessFlag,
          selectContactFlag: data.selectContactFlag,
          shouldShowPicStatement: getShouldShowPicStatement(data.lobs, submitValues.policyType),
        });
        dispatch({
          type: EM_REGIST_FETCH_USERNAME,
          userNames,
          countryCodeMap: data.isMobileUsed,
        });
        if (isEB) {
          dispatch(
            goTo(
              `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/input-password`,
            ),
          );
        } else if (isPnc) {
          /* eslint-disable no-lonely-if */
          if (data.selectContactFlag === 'N') {
            // free input username if user is insured
            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/input-password`,
              ),
            );
          } else if (namesNoAvaliable(userNames)) {
            const errorCode = 'ERROR 4';
            dispatch({
              type: EM_FINDMYPOLICY_FAIL,
              errorCode,
            });

            const errorConfig = getErrorConfig({
              apiCode: errorCode,
              featureCode: FEATURE_CODES.registration,
              policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
            });

            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/error?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`,
              ),
            );
          } else {
            // select username if user is policy owner
            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/select-username`,
              ),
            );
          }
        } else {
          /* eslint-disable no-lonely-if */
          if (data.insuredAccessFlag === 'Y') {
            // free input username if user is insured
            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/input-password`,
              ),
            );
          } else if (namesNoAvaliable(userNames)) {
            const errorCode = 'ERROR 4';
            dispatch({
              type: EM_FINDMYPOLICY_FAIL,
              errorCode,
            });

            const errorConfig = getErrorConfig({
              apiCode: errorCode,
              featureCode: FEATURE_CODES.registration,
              policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
            });

            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/error?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`,
              ),
            );
          } else {
            // select username if user is policy owner
            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/select-username`,
              ),
            );
          }
        }
      })
      .catch(error => {
        dispatch({ type: EM_REGIST_SERVER_REQ_COMPLETE });
        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          const { payload, reasonCode } = error.response.data.response;
          errorCode = reasonCode;
          const userContact =
            payload && payload.userContact ? payload.userContact : '';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
            errorData: payload,
            errorValues: {
              userContact,
            },
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.registration,
          policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/error?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`,
          ),
        );
      });
  };
};

export const emmaSubmitSelectedUserName = submitValues => {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EM_REGIST_SELECT_USERNAME,
      ...submitValues,
    });
    dispatch(
      goTo(
        `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/individual-policy/input-password`,
      ),
    );
  };
};

export const emmaSubmitPassword = (submitValues, fromPage) => {
  return async (dispatch, getState) => {
    const currStateVal = getState();
    const currLang = currStateVal.language.lang;
    const regObj = currStateVal.emmaRegistration;
    const { policyType, selectContactFlag, insuredAccessFlag, shouldShowPicStatement } = regObj;
    const isEB = policyType === 'company';
    const isLife = policyType === 'individual';
    const routeName = ROUTE_NAMES[policyType] || '';
    const featureName =
      {
        individual: 'poLife',
        company: 'poEB',
        pnc: 'poPNC',
      }[policyType] || '';

    let registrationRequest = {
      checkHash: regObj.checkHash,
      password: submitValues.password,
      acceptDataPolicy: submitValues.tnc_first_checkbox
        ? submitValues.tnc_first_checkbox.toString()
        : 'false',
      receiveNews: submitValues.tnc_second_checkbox
        ? submitValues.tnc_second_checkbox.toString()
        : 'false',
      acceptPIC: submitValues.tnc_third_checkbox
        ? submitValues.tnc_third_checkbox.toString()
        : 'false',
      // HKEMMA-102672 - default to 'Y' because of API validation must 'Y'
      // acceptPIPL: Boolean(submitValues.tnc_checkbox_4 && submitValues.tnc_checkbox_5 && submitValues.tnc_checkbox_6).toString(),
      acceptPIPL: 'true',
      ...(shouldShowPicStatement
        ? {
          [isEB ? 'eSettlement' : 'receiveClaimSettle']: submitValues.tnc_fourth_checkbox
            ? submitValues.tnc_fourth_checkbox.toString()
            : 'false',
        }
        : {
          receiveClaimSettle: 'false',
        }),
      locale: currLang,
      captchaToken: submitValues.captchaToken,
    };
    const contactIndex = (regObj.countryCodeMap || []).findIndex(
      item =>
        item.countryCode === regObj.countryCode &&
        item.mobile === regObj.mobileStr,
    );
    if (
      isEB ||
      (isLife && insuredAccessFlag === 'Y') ||
      selectContactFlag === 'N'
    ) {
      registrationRequest = {
        ...registrationRequest,
        contactType: submitValues.contactType,
        ...(submitValues.contactType === 'mobile'
          ? {
            countryCode: submitValues.mobileCountryCode
              ? submitValues.mobileCountryCode.toString()
              : '852',
            mobile: submitValues.mobileNo || '',
          }
          : {
            email: submitValues.email.toLowerCase() || '',
          }),
      };
    } else {
      registrationRequest = {
        ...registrationRequest,
        contactType: regObj.contactType,
        contactIndex:
          regObj.contactType === 'mobile'
            ? `${contactIndex}`
            : regObj.contactIndex.toString(),
      };
    }
    let registrationRedux = { ...registrationRequest };
    if (isEB || selectContactFlag === 'N') {
      registrationRedux = {
        ...registrationRedux,
        ...(submitValues.contactType === 'mobile'
          ? {
            countryCode: submitValues.mobileCountryCode.toString() || '',
            mobile: submitValues.mobileNo || '',
            mobileStr: submitValues.mobileNo || '',
          }
          : {
            email: submitValues.email.toLowerCase() || '',
            emailStr: submitValues.email.toLowerCase() || '',
          }),
      };
    } else {
      if (regObj.contactType === 'mobile') {
        registrationRedux = {
          ...registrationRedux,
          ...{
            countryCode: regObj.countryCodeMap[contactIndex].countryCode || '',
            mobile: regObj.countryCodeMap[contactIndex].mobile || '',
            mobileStr: regObj.countryCodeMap[contactIndex].mobile || '',
          },
        };
      } else if (
        submitValues.contactType === 'mobile' &&
        submitValues.mobileCountryCode &&
        submitValues.mobileNo
      ) {
        registrationRedux = {
          ...registrationRedux,
          ...{
            countryCode: submitValues.mobileCountryCode,
            mobile: submitValues.mobileNo,
            mobileStr: submitValues.mobileNo,
          },
        };
      } else if (submitValues.contactType === 'email' && submitValues.email) {
        registrationRedux = {
          ...registrationRedux,
          ...{
            email: submitValues.email.toLowerCase() || '',
            emailStr: submitValues.email.toLowerCase() || '',
          },
        };
      } else {
        registrationRedux = {
          ...registrationRedux,
          ...{
            email: regObj.email.toLowerCase() || '',
            emailStr: regObj.emailStr.toLowerCase() || '',
          },
        };
      }
    }
    dispatch({
      type: EM_REGIST_SELECT_USERNAME,
      ...registrationRedux,
    });
    dispatch({
      type: EM_REGIST_SERVER_REQ_START,
    });
    const queryParams = {
      featureName,
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await (config.isMockResponse
      ? Promise.resolve((await import('./mocks/submitPassword')).default)
      : muleSoftFetch(
        parseQueryString(
          `${config.webview.muleApiBaseUrl}/customers/registration`,
          queryParams,
        ),
        'post',
        { registrationRequest },
        option
      )
    )
      .then(() => {
        dispatch({ type: EM_REGIST_SERVER_REQ_COMPLETE });
        dispatch(
          goTo(
            `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/done`,
          ),
        );
      })
      .catch(error => {
        dispatch({ type: EM_REGIST_SERVER_REQ_COMPLETE });
        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          const { payload, reasonCode, reason } = error.response.data.response;
          errorCode = reasonCode;
          const userContact =
            payload && payload.userContact ? payload.userContact : '';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
            errorData: reason,
            errorValues: {
              userContact,
            },
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.registration,
          policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${config.webview.identityFEPath}/emma/signup/po/${routeName}/error?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`,
          ),
        );
      });
  };
};

export const emmaRegistReactivation = (payloadQ) => {
  return async (dispatch, getState) => {
    const currStateVal = getState();
    const regObj = currStateVal.emmaRegistration;
    const { payLoad, policyType, contactType, email, countryCode, mobile } =
      regObj;
    const queryData = payloadQ || payLoad;
    const token = queryData && queryData.token ? queryData.token : '';
    const captchaToken =
      queryData && queryData.captchaToken ? queryData.captchaToken : '';
    const isEB = policyType === 'company';
    const currLang = currStateVal.language.lang;
    dispatch({
      type: EM_REGIST_SERVER_REQ_START,
    });

    const tokenParam = {
      token,
    };

    const contactParam =
      contactType === 'email'
        ? {
          email: email.toLowerCase(),
          contactType,
        }
        : {
          countryCode,
          mobile,
          contactType,
        };

    const formData = {
      locale: currLang || 'en',
      ...(token === '' ? contactParam : tokenParam),
      captchaToken,
    };

    const queryParams = {
      featureName:
        queryData.code && queryData.code === 'nuc'
          ? 'reactivateuserCWP'
          : 'reactivateuserPO',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey
      }
    };
    await muleSoftFetch(
      parseQueryString(
        `${config.webview.muleApiBaseUrl}/customers/registration`,
        queryParams,
      ),
      'post',
      { registrationRequest: formData },
      option
    )
      .then(({ data }) => {
        dispatch({
          type: EM_REGIST_SERVER_KEEP_HASH,
          checkHash: data.checkHash,
        });
        dispatch({ type: EM_REGIST_SERVER_REQ_COMPLETE });
        dispatch(
          goTo(`/${currLang}/${config.webview.identityFEPath}/emma/login`),
        );
      })
      .catch(error => {
        dispatch({ type: EM_REGIST_SERVER_REQ_COMPLETE });
        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          errorCode = error.response.data.response.reasonCode;
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
            errorData: error.response.data.response.payload,
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.registration,
          policyTypeCode: POLICY_TYPE_CODES[policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${config.webview.identityFEPath}/emma/signup/po${isEB ? '/employee-benefit' : '/individual-policy'
            }/error?errorCode=${errorConfig.errorCode}`,
          ),
        );
      });
  };
};
